import React from "react";
import PropTypes from "prop-types";
import { styled, alpha } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";

import AccordionSummaryContent from "./AccordionSummaryContent";
import ResultToolbar from "./ResultToolbar";

const StyledCard = styled(Card, { shouldForwardProp: (prop) => prop !== "selected" })(
  ({ theme, selected }) => ({
    marginBottom: theme.spacing(1),
    border: `1px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
    backgroundColor: selected
      ? alpha(theme.palette.primary.main, 0.04)
      : theme.palette.background.paper,
    boxShadow: "none",
    borderRadius: theme.shape.borderRadius,
    transition: "border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease",
    "&:hover": {
      borderColor: selected ? theme.palette.primary.main : theme.palette.text.secondary,
      boxShadow: "0 1px 2px rgba(15,23,42,0.04), 0 1px 3px rgba(15,23,42,0.06)",
    },
  })
);

const Row = styled("div")({
  display: "flex",
  alignItems: "stretch",
  width: "100%",
});

const ClickableArea = styled(CardActionArea)({
  flex: 1,
  minWidth: 0,
  textAlign: "left",
  alignItems: "stretch",
});

export default function Result({ result, selected, onSelect }) {
  return (
    <StyledCard selected={selected} variant="outlined">
      <Row>
        <ClickableArea onClick={() => onSelect && onSelect(result)}>
          <AccordionSummaryContent result={result} />
        </ClickableArea>
        <ResultToolbar result={result} />
      </Row>
    </StyledCard>
  );
}

Result.propTypes = {
  result: PropTypes.object,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
};
